import {createStyles, makeStyles, Theme} from '@material-ui/core';
import { LIGHT_GRAY, PRIMARY_RED } from '../../../const/colors';

const useStyles = makeStyles((theme:Theme) =>
    createStyles({
        container:{
            paddingLeft:30,
            paddingRight:30
        },
        makeAppointment:{
            color: PRIMARY_RED,
            fontSize:20,
            
        },
        button:{
            width:300,
            whiteSpace:'normal',
            wordWrap:'break-word',
        },
        [theme.breakpoints.down('sm')]: {
            button:{
                marginTop:16,
                width:'100%'
                
            }
        }
    }),
);

export default useStyles;
